<template>
  <div class="payment-modal">
    <div class="payment-modal__container">
      <button :disabled="loaders.payment" class="payment-modal__close" @click="closeDialog">
        <nuxt-icon name="close" />
      </button>
      <div class="payment-modal__content">
        <div class="payment-modal__header">
          <h1
            v-if="title"
            :class="[
              'h2_title text-center',
              { 'payment-modal__title': !showDescription },
              locale
              ]"
          >
            {{ $t('oldTranslations.payments.selectPaymentMethod') }}
          </h1>
        </div>
        <component
          :is="form"
          :configs="paymentData"
          :params="paymentParams"
          :stage="stage"
          :show-description="showDescription"
          :trial="trial"
          :is-super-discount="isSuperDiscount"
          :selected-plan-id="selectedPlanId"
          @on-success="onSuccess"
          @action="action"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useLoader } from '~/composables/loader.ts';

const props = defineProps({
  title: {
    type: Boolean,
    default: true,
  },
  showDescription: {
    type: Boolean,
    default: true,
  },
  trial: {
    type: Boolean,
    default: false,
  },
  paymentData: {
    type: Object,
    required: true,
  },
  paymentParams: {
    type: Object,
    required: true,
  },
  isSuperDiscount: {
    type: Boolean,
    default: false,
  },
  selectedPlanId: {
    type: Number,
    default: 1,
  },
  form: {
    type: String,
    default: 'BasicCheckoutForm',
  },
  stage: {
    type: String,
  },
  action: {
    type: Function,
  },
});
const emit = defineEmits(['closed', 'action', 'on-success']);
const { toggleComponent } = useModals();
const form = computed(() => defineAsyncComponent(() => import(`../../payment/checkoutForms/${props.form}.vue`)));
const { loaders } = useLoader();
const { locale } = useI18n();
function closeDialog() {
  toggleComponent();
  emit('closed');
}
function onSuccess() {
  emit('on-success');
  emit('action');
}
</script>

<style lang="scss" scoped>
.payment-modal {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;

  &__container {
    position: relative;
    max-width: 600px;
    margin: 0 auto;
    background: $white;
    border-radius: 16px 16px 0 0;
    padding: 24px 32px;
    height: 95dvh;
    overflow-y: auto;
  }

  &__title {
    margin-bottom: 16px;
  }

  &__close {
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    background: transparent;
    border: none;

    & .nuxt-icon {
      color: $icon-gray;
      line-height: 0;
      font-size: 32px;
    }
  }
}
</style>
